<template>
  <PropertyDetailsCard>
    <template #title>Title</template>
    <template #action>
      <PropertyDetailsCardEditButton @click="showModal" />
    </template>

    <View direction="column">
      <Text gap="sm" class="title" variant="h2">
        {{ property?.displayName }}
      </Text>
    </View>

    <PropertyTitleModal ref="titleModalRef" />
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { Text, View } from '@tallo/design-system';
import { usePropertyStore } from '@tallo/investor/property';
import { PropertyDetailsCard, PropertyDetailsCardEditButton } from '@tallo/property';

import PropertyTitleModal from '../../../components/property-title-modal.vue';

const propertyStore = usePropertyStore();
const property = computed(() => propertyStore.property);

const titleModalRef = ref<InstanceType<typeof PropertyTitleModal>>();

function showModal() {
  titleModalRef.value?.modalRef?.show();
}
</script>

<style scoped lang="scss"></style>
